import { haptic } from '../telegram';

/**
 * Six cells for the six-digit code.
 *
 * A single field with letter-spacing showed neither how many digits were in nor
 * which one was next, and on a phone the digits drifted away from the caret.
 * The cells are only paint: the real input lies transparent on top of them, so
 * the system keyboard, paste and the one-time-code autofill all keep working.
 */
export default function CodeInput({
  value,
  length,
  refused = false,
  onChange,
}: {
  value: string;
  length: number;
  /**
   * The code that was typed here came back refused.
   *
   * The cells say so themselves rather than leaving it to the sentence under
   * them: the eye is on the row it has just filled, and a line that appears
   * below the button is both somewhere else and something that moves the page
   * while the keyboard is up. The sentence stays - it is the one thing that
   * says *which* refusal this is - and this is what carries it back up to where
   * the digits are.
   */
  refused?: boolean;
  onChange: (value: string) => void;
}) {
  // The cell that is about to be filled. Once the code is complete it is the
  // last one, so the outline never leaves the row.
  const active = Math.min(value.length, length - 1);

  return (
    <div className={refused ? 'digits digits--refused' : 'digits'}>
      {Array.from({ length }, (_, index) => (
        <div key={index} className={index === active ? 'digit digit--active' : 'digit'}>
          {value[index] ?? ''}
        </div>
      ))}
      <input
        className="digits-field"
        inputMode="numeric"
        autoComplete="one-time-code"
        aria-label="Код спевки"
        maxLength={length}
        value={value}
        onChange={(event) => {
          const next = event.target.value.replace(/\D/g, '').slice(0, length);
          // A tick per digit that landed, not per keystroke: a rejected letter
          // moved nothing, and confirming it would be haptics as decoration.
          if (next.length > value.length) haptic('selection');
          onChange(next);
        }}
      />
    </div>
  );
}
